import axiosClient from '../axiosClient';

export const getRevenueReport = (params) =>
  axiosClient.get('/admin/reports/revenue', { params });

export const exportRevenueReport = (params) =>
  axiosClient.get('/admin/reports/revenue/export', { params, responseType: 'blob' });

export const getGSTReport = (params) =>
  axiosClient.get('/admin/reports/gst', { params });

export const exportGSTReport = (params) =>
  axiosClient.get('/admin/reports/gst/export', { params, responseType: 'blob' });

export const getTDSReport = (params) =>
  axiosClient.get('/admin/reports/tds', { params });

export const exportTDSReport = (params) =>
  axiosClient.get('/admin/reports/tds/export', { params, responseType: 'blob' });
